<template>
    <div>
        <b-card class="mt-2">
            <b-row>
                <b-col>
                    <h4>Extrato Financeiro</h4>
                </b-col>
            </b-row>
            <b-row align-v="end">
                <b-col cols="2">
                    <label>Data Inicial</label>
                    <date-picker v-model="inicio" :config="datePickerConfig" :disabled="loading"></date-picker>
                </b-col>
                <b-col cols="2">
                    <label>Data Final</label>
                    <date-picker v-model="fim" :config="datePickerConfig" :disabled="loading"></date-picker>
                </b-col>
                <b-col>
                    <b-button variant="primary" @click="getRelatorios()" :disabled="loading">
                        <i class="fas fa-search"></i> Buscar
                    </b-button>
                    <b-button variant="secondary" @click="clear()" :disabled="loading" class="ml-2" title="Limpar">
                        <i class="fas fa-broom"></i>
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col cols=2>
                    <b-form-select id="per-page-select" v-model="perPage" :options="['5', '10', '20', '50', '100']"
                        :disabled="loading" @change="getRelatorios()" title="Por Página" size="sm"></b-form-select>
                </b-col>
                <b-col>
                    <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" align="fill" size="sm"
                        :disabled="loading" class="my-0" @input="getRelatorios()"></b-pagination>
                </b-col>
                <b-col cols="2" class="text-right">
                    Total: {{ total }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-table :items="items" :fields="fields" stacked="md" show-empty small :busy="loading">
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Buscando...</strong>
                        </div>
                    </template>
                    <template #cell(actions)="row">
                        <b-button variant="primary" size="sm" @click="viewFile(row.item.url)" class="mr-1">
                            <i class="fas fa-file-pdf"></i>
                        </b-button>
                    </template>
                </b-table>
            </b-row>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "extrato-financeiro",

    data() {
        return {
            datePickerConfig: {
                'format': 'DD/MM/YYYY',
                'showClose': true
            },
            inicio: "",
            fim: "",
            loading: false,
            items: [],
            fields: [
                { key: 'empresa.nome', label: 'Faturado' },
                {
                    key: 'inicio', label: 'Data Inicial',
                    formatter: (value) => {
                        return moment(value).format("DD/MM/YYYY")
                    },
                },
                {
                    key: 'fim', label: 'Data Final',
                    formatter: (value) => {
                        return moment(value).format("DD/MM/YYYY")
                    },
                },
                { key: 'lote_protheus', label: 'Lote' },
                { key: 'actions', label: '' },
            ],
            perPage: 10,
            currentPage: 1,
            total: 0
        }
    },
    methods: {
        clear() {
            this.inicio = ""
            this.fim = ""
        },
        getRelatorios() {
            const vm = this;
            const params = {
                perPage: this.perPage,
                page: this.currentPage,
                inicio: this.inicio,
                fim: this.fim
            }
            vm.loading = true
            axios.get('/distribuidor/relatorios/financeiro/list', { params: params })
                .then((response) => {
                    vm.items = response.data.data;
                    vm.total = response.data.total;
                }).catch((error) => {
                    console.log(error)
                }).finally(() => {
                    vm.loading = false
                })
        },
        viewFile(path) {
            window.open('/' + path, "_blank");
        }
    },
    mounted() {
        this.getRelatorios();
    }
}


</script>

<style></style>


// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/relatorio/ExtratoFinanceiro.vue